"use client"

import colors from "@/lib/theme/colors"
import { Pagination as MuiPagination, styled } from "@mui/material"
import React from "react"

interface Props {
  count: number
  page: number
  onChange: (page: number) => void
}

const StyledPagination = styled(MuiPagination)`
  & .MuiPaginationItem-root {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid ${colors.directGray};
    color: ${colors.directGray};
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    font-family: inherit;
    margin: 0 8px;

    &.Mui-selected {
      background-color: ${colors.directYellow};
      border-color: ${colors.directYellow};
      color: ${colors.directBlack};

      &:hover {
        background-color: ${colors.directYellow};
      }
    }

    &:hover {
      background-color: ${colors.directYellow};
      border-color: ${colors.directYellow};
      color: ${colors.directBlack};
    }
  }

  & .MuiPaginationItem-ellipsis {
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .MuiPaginationItem-previousNext {
    border: none;
    background: transparent;
    color: ${colors.directBlack};
    width: 20px;
    height: 20px;
    min-width: 20px;
  }

  & .Mui-disabled {
    color: ${colors.directBlack};
    opacity: 1;
  }
`

const Pagination = ({ count, page, onChange }: Props): React.ReactElement => {
  return (
    <StyledPagination
      count={count}
      page={page}
      onChange={(_, value) => onChange(value)}
      shape="rounded"
      siblingCount={1}
      boundaryCount={1}
    />
  )
}

export default Pagination
